import { Domain, LocalizedKeyValue, Market } from '../dataref.model';
import { CommentSearchContent, FieldFilter } from '../search.model';
import { DisplayData, DomainMarketLangList, FilterConfig } from '../../components/data-table-manager/data-table-manager.component';
import { Subject } from 'rxjs';
import { ColumnConfiguration } from '../generic/column-configuration.model';
import { MatTableDataSource } from '@angular/material/table';
import { FacetGroup } from '../../components/facet-list/facet-list.component';

export interface DomainMarketLang {
  domain: string;
  market: string;
  lang: string;
}

export class CommentBaseComponent {
  columnConfigs: ColumnConfiguration<CommentSearchContent>[] = [];
  tableData = new MatTableDataSource<CommentSearchContent>([]);
  domains: Domain[] = [];
  markets: Market[] = [];
  domainMarketLang: DomainMarketLangList = {
    domains: [],
    markets: [],
    languages: [],
  };
  commentReasons: LocalizedKeyValue[];
  commentStatuses: LocalizedKeyValue[];
  commentDomainMarketLang: DomainMarketLang = {
    domain: '',
    market: '',
    lang: '',
  };
  fieldFilters: FieldFilter[];
  pageIndex = 0;
  pageSize = 20;
  displayInfo: DisplayData = {
    resultsMessage: '',
    dataLength: 0,
    noDataMessage: '',
    totalPages: 0,
  };
  facetGroups: Subject<FacetGroup[]> = new Subject<FacetGroup[]>();
  DEFAULT_FILTER_CONFIG: FilterConfig = {
    isFacetFilterEnabled: true,
    isFieldFilterEnabled: false,
    isSearchEnabled: true,
  };
  defaultSortActive?: string;
  defaultSortDirection: 'asc' | 'desc' = 'desc';
}
